import React from "react";
import { Box } from "@mui/material";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * 業務内容表示セクション
 */
export default function SkillSheetMainWorkContent({ workSections }) {
  const sections = Array.isArray(workSections) ? workSections : [];

  // 未入力の場合は - を表示
  if (sections.length === 0) {
    return <Box sx={{ p: 0.5, fontSize: FONT_SIZE.XXS }}>-</Box>;
  }
  return (
    <Box sx={{ p: 0.5, fontSize: FONT_SIZE.XXS, lineHeight: 1.2 }}>
      {sections.map((section, idx) => (
        <Box key={`${section.title}-${idx}`} sx={{ mb: 0.5 }}>
          {/* セクション見出し */}
          <Box sx={{ fontWeight: 700 }}>{section.title}</Box>

          {/* 業務内容リスト */}
          <Box component="ul" sx={{ m: 0, listStyleType: "none" }}>
            {(section.items || []).map((item, i) => (
              <Box
                key={`${idx}-${i}`}
                component="li"
                sx={{ fontSize: FONT_SIZE.XXS, lineHeight: 1.7 }}
              >
                {/* ・小項目名 */}
                <Box sx={{ whiteSpace: "pre-wrap" }}>・{item.header}</Box>

                {/* 本文 */}
                {item.content && item.content.trim() !== "" && (
                  <Box
                    sx={{
                      ml: 2,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {item.content}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
